 
<template>
  
<v-bottom-navigation
 class="bottom-nav"

 sticky
  v-model="selectedNav"
  style=" height:70px"
>


        <v-btn to="/" class="nav-bottom-btn  " value="home" style="  ">
          <v-icon class="nav-bottom-btn-icon" size="31">mdi-view-dashboard-outline</v-icon>
               <span>Dashboard</span>
        </v-btn> 

        <v-btn to="/quote" class="nav-bottom-btn  " value="home" style="  ">
          <v-icon class="nav-bottom-btn-icon" size="31">mdi-currency-usd</v-icon>
               <span>Quote</span>
        </v-btn>
        <v-btn to="/jobs" class="nav-bottom-btn  " value="home" style="  ">
          <v-icon class="nav-bottom-btn-icon" size="31">mdi-briefcase-outline</v-icon>
               <span>Jobs</span>
        </v-btn>
 

        <v-btn to="/crm/leads" class="nav-bottom-btn  " value="home" style="  ">
          <v-icon class="nav-bottom-btn-icon" size="31">mdi-message-outline</v-icon>
               <span>Leads</span>
        </v-btn>
        <v-btn  :onSignOut="onSignOut"  @click.prevent="showMenu = true" class="nav-bottom-btn  " value="menu" style=" ">

          
          <v-icon class="nav-bottom-btn-icon" size="31">mdi-dots-grid</v-icon>
          
          <span>Menu</span>

 
        </v-btn>

</v-bottom-navigation>
<Menu v-model="showMenu" :onSignOut="onSignOut" />
</template>













<script setup>
import { ref } from "vue"
import Menu from "../components/general/Menu.vue"







const showMenu = ref(false)
const selectedNav = ref("home")

defineProps({
  onSignOut: {
    type: Function,
    required: true
  },
  userName: { type: String, default: '' } 
})


</script>








<style scoped>
.nav-bottom-btn span{
  font-weight:300;
  font-size:9px;
}
.nav-bottom-btn {
  flex: 1 1 0;
  min-width: 0;      /* IMPORTANT */
  padding: 0;
}
.v-bottom-navigation {
  border-top: 1px solid rgba(255,255,255,0.08);
}

@media print {
  .bottom-nav {
    display: none !important;
  }
}
</style>




<style>
 

 

 
</style>
